export const languages = [
  {
    label: 'language.polish',
    code: 'pl',
  },
  {
    label: 'language.english',
    code: 'en',
  },
];
